import { render, staticRenderFns } from "./ItemsNavigator.vue?vue&type=template&id=a10bb3be&"
import script from "./ItemsNavigator.vue?vue&type=script&lang=js&"
export * from "./ItemsNavigator.vue?vue&type=script&lang=js&"
import style0 from "./ItemsNavigator.vue?vue&type=style&index=0&id=a10bb3be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports